var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section__gray"},[_c('div',{staticClass:"pl-3"},[_c('h1',{staticClass:"color-primary"},[_vm._v(_vm._s(_vm.headerCopy))])])])}
var staticRenderFns = []

export { render, staticRenderFns }